<div class="header">
  <h2>Events</h2>
  <!-- <div class="menu">
    <button
      mat-icon-button
      [matMenuTriggerFor]="menu"
      aria-label="Example icon-button with a menu"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#000000"
      >
        <path
          d="M400-240v-80h160v80H400ZM240-440v-80h480v80H240ZM120-640v-80h720v80H120Z"
        />
      </svg>
    </button>
    <mat-menu #menu="matMenu">
      <ul (click)="$event.stopPropagation()">
        <li>
          <mat-checkbox
            [color]="'primary'"
            [checked]="selectedArrangeEventsBy.has('nested')"
            (click)="ArrangeByTypeClicked('nested')"
            >Nested Events</mat-checkbox
          >
        </li>
        <li>
          <mat-checkbox
            [color]="'primary'"
            [checked]="selectedArrangeEventsBy.has('overlapped')"
            (click)="ArrangeByTypeClicked('overlapped')"
            >Overlapping Events</mat-checkbox
          >
        </li>
        <li>
          <mat-checkbox
            [color]="'primary'"
            [checked]="selectedArrangeEventsBy.has('gap')"
            (click)="ArrangeByTypeClicked('gap')"
            >Concat by Frames Gap</mat-checkbox
          >
          <input
            type="number"
            min="0"
            step="1"
            (keydown)="calculateGap($event)"
            (change)="calculateGap($event, true)"
            [disabled]="!selectedArrangeEventsBy.has('gap')"
          />
        </li>
      </ul>
    </mat-menu>
  </div> -->
</div>

<div
  class="events"
  *ngIf="orderedEvents && orderedEvents.length > 0"
  #eventsListRef
>
  <ng-container *ngFor="let events of orderedEvents; let index = index">
    <div
      class="events-wrapper"
      *ngIf="events.length > 1; else singleEvent"
      (click)="onMultiEventsClicked($event, index)"
      [ngClass]="{ selected: index == selectedEventIndex }"
      (onVisible)="onEventVisible(events, $event)"
      [scrollableContainer]="eventsListRef"
      observeVisibility
      >


      <div class="multi-event" [attr.data-events-list]="index">
        <div class="data">
          <svg
            (click)="toggleEvents($event, index)"
            class="more-arrow"
            [class.open]="openedNestedEvents.has(index)"
            width="17"
            height="17"
            viewBox="0 0 17 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g opacity="0.86">
              <path
                d="M5.76953 14.5701L11.7695 8.57007L5.76953 2.57007L5.76953 14.5701Z"
                fill="black"
                fill-opacity="0.54"
              />
            </g>
          </svg>
          <div class="info">
            <div class="timetrange">{{ multiEventsTimeRange(events) }}</div>
            <div [class]="{ title: true, approved: areEventsAprroved(events) }">
              <span> {{ events[0].title }} </span>
            </div>
          </div>
        </div>
        <div class="frames">
          <img
            [src]="
              getMultiEventsStartFrame(events) || '/assets/ccstudio/loading.svg'
            "
          />
          <img
            [src]="
              getMultiEventsEndFrame(events) || '/assets/ccstudio/loading.svg'
            "
          />
        </div>
      </div>
      <ul [class.hidden]="!openedNestedEvents.has(index)">
        <li *ngFor="let event of events">
          <evrideo-content-control-studio-event
            [event]="event"
            [view-model]="vm"
            (click)="onEventClicked($event, event.id)"
            (revert-clicked)="onRevertEventClicked($event)"
            [ngClass]="{
              selected:
                event.id == selectedEventId && selectedEventIndex != index
            }"
            [attr.data-event-id]="event.id"

          ></evrideo-content-control-studio-event>
        </li>
      </ul>
    </div>
    <ng-template #singleEvent>
      <evrideo-content-control-studio-event
        [event]="events[0]"
        [view-model]="vm"
        (click)="onEventClicked($event, events[0].id)"
        (revert-clicked)="onRevertEventClicked($event)"
        [ngClass]="{ selected: events[0].id == selectedEventId }"
        [attr.data-event-id]="events[0].id"
        (onVisible)="onEventVisible(events, $event)"
        [scrollableContainer]="eventsListRef"
        observeVisibility
      ></evrideo-content-control-studio-event>
    </ng-template>
  </ng-container>
</div>
